/**
 * 用户相关接口（登录 / 注册 / 账号查重）
 */
import request from './request'

/**
 * 登录
 * @param {{no: string, password: string}} data
 */
export function login(data) {
  return request.post('/user/login', data)
}

/**
 * 注册（游客自助开通普通账号）
 * @param {{no: string, name: string, password: string, phone: string, age?: number, sex?: number}} data
 */
export function register(data) {
  return request.post('/user/register', data)
}

/**
 * 按账号查询是否存在
 * @param {string} no
 */
export function findByNo(no) {
  return request.get('/user/findByNo', { params: { no } })
}

/**
 * 查询用户公开资料（裙星空间点击头像/昵称弹窗使用）
 * 后端已脱敏，不返回密码
 * @param {string} no 账号
 */
export function getUserProfile(no) {
  return request.get('/user/profile', { params: { no } })
}

/**
 * 打赏：用星裙币向对方转账
 * @param {{fromNo:string, toNo:string, amount:number}} data
 */
export function tipUser(data) {
  return request.post('/user/tip', data)
}

/**
 * 更新当前登录用户自己的头像
 * @param {{no:string, avatar:string}} data
 */
export function updateAvatar(data) {
  return request.post('/user/updateAvatar', data)
}

/**
 * 个人设置：用户自助修改自己的资料（昵称/年龄/性别/电话/密码/头像）
 * @param {{no:string, name?:string, age?:number, sex?:number, phone?:string, password?:string, avatar?:string}} data
 */
export function updateProfile(data) {
  return request.post('/user/updateProfile', data)
}
